<template>
    <div class='accept-price-offer-project-action'>
        <button @click="showModal = true" type="button" class="button is-primary">Acceptér tilbud</button>

        <b-modal :active="showModal" :canCancel="['escape']">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Acceptér tilbud</p>
                </header>

                <section class="modal-card-body">
                    <p>For at acceptere tilbuddet, skal du blot krydse af herunder og trykke Acceptér.</p>
                    <br>

                    <p>Tilbuddet er: <strong>{{project.offered_price}} kr. {{project.price_type === 'unit' ? 'for hele opgaven' : 'pr. time'}}</strong></p>

                    <template v-if="project.price_type !== 'unit'">
                        <template v-if="project.hours_used">
                            <p>Den studerende anslår at der skal bruges <strong>{{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}}</strong> på opgaven.</p>
                            <br>
                            <p>Tilbuddet bliver derfor på: <strong>{{project.hours_used * project.offered_price}} kr. eks. moms</strong> ({{project.hours_used}} {{project.hours_used === 1 ? 'time' : 'timer'}} á {{project.offered_price}} kr.).</p>
                        </template>

                        <p v-else>Den studerende har ikke anslået et antal timer endnu.</p>
                    </template>

                    <quick-contact-info-update v-if="isMissingAddress" @updated="() => { this.hasAddedAddress = true }" />

                    <template v-if="!isMissingAddress || hasAddedAddress">
                        <br>
                        <p>Når du har accepteret tilbuddet, begynder den studerende på opgaven.</p>
                        <br>
                        <p>Du vil stadig kunne skrive med dem, men du kan ikke længere annullere opgaven, uden at kontakte Taskflex.</p>
                        <br>

                        <div class="has-text-centered">
                            <b-checkbox v-model="acceptTerms">Jeg accepterer hermed tilbuddet, og at opgaven påbegyndes nu.</b-checkbox>

                            <p v-if="!acceptTerms" class="help is-danger">Du skal acceptere for at fortsætte</p>
                        </div>
                    </template>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button is-danger" @click="showModal = false" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-success" :class="{'is-loading': isSubmitting}" @click="submit" :disabled="veeErrors.any() || !acceptTerms || (isMissingAddress && !hasAddedAddress)">Acceptér</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import ProjectService from '@/taskflex/projects/services/ProjectService';
    import { mapGetters } from 'vuex';
    import QuickContactInfoUpdate from '@/taskflex/customers/components/QuickContactInfoUpdate';

    export default {
        data() {
            return {
                showModal: false,
                acceptTerms: false,
                isSubmitting: false,
                isMissingAddress: false,
                hasAddedAddress: false,
            };
        },

        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters('auth', [
                'currentUserAccount',
                'isCustomer',
            ]),
        },

        mounted() {
            const {
                address,
                city,
                postcode,
            } = this.currentUserAccount;

            this.isMissingAddress = (!address || !city || !postcode);
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                const options = {
                    offer: this.offer,
                };

                this.isSubmitting = true;

                ProjectService.acceptPriceOffer(this.project.id, options, ({ data }) => {
                    this.isSubmitting = false;
                    this.showModal = false;

                    this.$emit('accepted', data);
                });
            },
        },

        components: {
            QuickContactInfoUpdate,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectActions/AcceptPriceOfferProjectAction.vue